import { render } from "./PaymentChanelForm.vue?vue&type=template&id=2b485058&ts=true"
import script from "./PaymentChanelForm.vue?vue&type=script&lang=ts"
export * from "./PaymentChanelForm.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__